module.exports = __webpack_public_path__ + "img/icon1.cb79201b.png";